import {Component, OnInit} from '@angular/core';
import {Location} from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import * as firebase from 'firebase';
import {ToastService} from '../typescripts/pro/alerts'

@Component({
  selector: 'app-adminlistados-usuarios-crear',
  templateUrl: './adminlistados-usuarios-crear.component.html',
  styleUrls: ['./adminlistados-usuarios-crear.component.scss']
})
export class AdminlistadosUsuariosCrearComponent implements OnInit {

  state = 'crear';
  objectId;
  user;
  userId;
  ampa;
  optionsSelectTipoUsuario: Array<any>;
  selectedfilename;

  rol;
  tut_1_email;
  password;
  tut_1_dni;
  tut_1_apellido1;
  tut_1_apellido2;
  tut_1_nombre;
  tut_1_telefono1;
  tut_1_telefono2;
  tut_2_email;
  tut_2_dni;
  tut_2_apellido1;
  tut_2_apellido2;
  tut_2_nombre;
  tut_2_telefono1;
  tut_2_telefono2;
  domicilio_calle_1;
  domicilio_numero_1;
  domicilio_escalera_1;
  domicilio_piso_1;
  domicilio_puerta_1;
  domicilio_poblacion_1;
  domicilio_codigo_postal_1;
  domicilio_provincia_1;
  domicilio_telefono_1;
  domicilio2_calle_1;
  domicilio2_numero_1;
  domicilio2_escalera_1;
  domicilio2_piso_1;
  domicilio2_puerta_1;
  domicilio2_poblacion_1;
  domicilio2_codigo_postal_1;
  domicilio2_provincia_1;
  domicilio2_telefono_1;
  cuenta_bancaria_titular;
  cuenta_bancaria_dni;
  cuenta_bancaria_iban_1;
  cuenta_bancaria_iban_2;
  cuenta_bancaria_iban_3;
  cuenta_bancaria_iban_4;
  cuenta_bancaria_iban_5;
  comentarios;
  checkbox_usuario_leida_cesion_imagenes;
  checkbox_usuario_cesion_imagenes;
  date_registered;


  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private _location: Location,
    private toast: ToastService,
  ) {
    //INICIALIZACIONES

    this.optionsSelectTipoUsuario = [
            { value: 'user', label: 'Padre/madre' },
            { value: 'admin', label: 'AMPA' },
        ];

    //comprobamos si estamos pasando parametros por la url para editar o ver un documento
    this.route.params.subscribe(params => {
        if(params.state){
          if(params.state === 'editar'){
                this.state = 'editar';
          } else if(params.state === 'ver'){
                  this.state = 'ver';
              }
              this.objectId = params.id;

              console.log('this state: ', this.state);
              console.log('objectId id: ', this.objectId);
        }
    })

    //obtener datos del usuario admin logueado para saber a que AMPA pertenece
    this.userId = localStorage.getItem('userId');
    console.log('UserId', this.userId);
    if(!this.userId){
      this.router.navigate[('')]
    } else {
      firebase.firestore().collection('admins').doc(this.userId)
      .get()
      .then((doc)=>{
        this.user = doc.data();
        console.log('user', this.user)
        console.log('user ampa', this.user.ampa)

      })
    }
  }


  ngOnInit() {}


  //guardar datos de centro escolar cuando se crea
  guardar(){
    var now = new Date()
    firebase.firestore().collection('usuarios').add({
    ampa: this.user.ampa || '',
    rol : this.rol || '',
    tut_1_email : this.tut_1_email || '',
    password : this.password || '',
    tut_1_dni : this.tut_1_dni || '',
    tut_1_apellido1 : this.tut_1_apellido1 || '',
    tut_1_apellido2 : this.tut_1_apellido2 || '',
    tut_1_nombre : this.tut_1_nombre || '',
    tut_1_telefono1 : this.tut_1_telefono1 || '',
    tut_1_telefono2 : this.tut_1_telefono2 || '',
    tut_2_email : this.tut_2_email || '',
    tut_2_dni : this.tut_2_dni || '',
    tut_2_apellido1 : this.tut_2_apellido1 || '',
    tut_2_apellido2 : this.tut_2_apellido2 || '',
    tut_2_nombre : this.tut_2_nombre || '',
    tut_2_telefono1 : this.tut_2_telefono1 || '',
    tut_2_telefono2 : this.tut_2_telefono2 || '',
    domicilio_calle_1 : this.domicilio_calle_1 || '',
    domicilio_numero_1 : this.domicilio_numero_1 || '',
    domicilio_escalera_1 : this.domicilio_escalera_1 || '',
    domicilio_piso_1 : this.domicilio_piso_1 || '',
    domicilio_puerta_1 : this.domicilio_puerta_1 || '',
    domicilio_poblacion_1 : this.domicilio_poblacion_1 || '',
    domicilio_codigo_postal_1 : this.domicilio_codigo_postal_1 || '',
    domicilio_provincia_1 : this.domicilio_provincia_1 || '',
    domicilio_telefono_1 : this.domicilio_telefono_1 || '',
    domicilio2_calle_1 : this.domicilio2_calle_1 || '',
    domicilio2_numero_1 : this.domicilio2_numero_1 || '',
    domicilio2_escalera_1 : this.domicilio2_escalera_1 || '',
    domicilio2_piso_1 : this.domicilio2_piso_1 || '',
    domicilio2_puerta_1 : this.domicilio2_puerta_1 || '',
    domicilio2_poblacion_1 : this.domicilio2_poblacion_1 || '',
    domicilio2_codigo_postal_1 : this.domicilio2_codigo_postal_1 || '',
    domicilio2_provincia_1 : this.domicilio2_provincia_1 || '',
    domicilio2_telefono_1 : this.domicilio2_telefono_1 || '',
    cuenta_bancaria_titular : this.cuenta_bancaria_titular || '',
    cuenta_bancaria_dni : this.cuenta_bancaria_dni || '',
    cuenta_bancaria_iban_1 : this.cuenta_bancaria_iban_1 || '',
    cuenta_bancaria_iban_2 : this.cuenta_bancaria_iban_2 || '',
    cuenta_bancaria_iban_3 : this.cuenta_bancaria_iban_3 || '',
    cuenta_bancaria_iban_4 : this.cuenta_bancaria_iban_4 || '',
    cuenta_bancaria_iban_5 : this.cuenta_bancaria_iban_5 || '',
    comentarios : this.comentarios || '',
    checkbox_usuario_leida_cesion_imagenes : this.checkbox_usuario_leida_cesion_imagenes || '',
    checkbox_usuario_cesion_imagenes : this.checkbox_usuario_cesion_imagenes || '',
    date_registered: now || '',
    })
    .then((docRef)=>{
      if (docRef)
        console.log('Creado ', docRef.id)
      this.showSuccess('Datos guardatos correctamente.');
      this.router.navigate(['/admin/listados-usuarios'])
    })
  }

  // actualizamos los datos de algunos campos del centro escolar
  editar(){
  var now = new Date()
  firebase.firestore().collection('usuarios').doc(this.objectId).update({
    ampa: this.user.ampa || '',
    rol : this.rol || '',
    tut_1_email : this.tut_1_email || '',
    tut_1_dni : this.tut_1_dni || '',
    tut_1_apellido1 : this.tut_1_apellido1 || '',
    tut_1_apellido2 : this.tut_1_apellido2 || '',
    tut_1_nombre : this.tut_1_nombre || '',
    tut_1_telefono1 : this.tut_1_telefono1 || '',
    tut_1_telefono2 : this.tut_1_telefono2 || '',
    tut_2_email : this.tut_2_email || '',
    tut_2_dni : this.tut_2_dni || '',
    tut_2_apellido1 : this.tut_2_apellido1 || '',
    tut_2_apellido2 : this.tut_2_apellido2 || '',
    tut_2_nombre : this.tut_2_nombre || '',
    tut_2_telefono1 : this.tut_2_telefono1 || '',
    tut_2_telefono2 : this.tut_2_telefono2 || '',
    domicilio_calle_1 : this.domicilio_calle_1 || '',
    domicilio_numero_1 : this.domicilio_numero_1 || '',
    domicilio_escalera_1 : this.domicilio_escalera_1 || '',
    domicilio_piso_1 : this.domicilio_piso_1 || '',
    domicilio_puerta_1 : this.domicilio_puerta_1 || '',
    domicilio_poblacion_1 : this.domicilio_poblacion_1 || '',
    domicilio_codigo_postal_1 : this.domicilio_codigo_postal_1 || '',
    domicilio_provincia_1 : this.domicilio_provincia_1 || '',
    domicilio_telefono_1 : this.domicilio_telefono_1 || '',
    domicilio2_calle_1 : this.domicilio2_calle_1 || '',
    domicilio2_numero_1 : this.domicilio2_numero_1 || '',
    domicilio2_escalera_1 : this.domicilio2_escalera_1 || '',
    domicilio2_piso_1 : this.domicilio2_piso_1 || '',
    domicilio2_puerta_1 : this.domicilio2_puerta_1 || '',
    domicilio2_poblacion_1 : this.domicilio2_poblacion_1 || '',
    domicilio2_codigo_postal_1 : this.domicilio2_codigo_postal_1 || '',
    domicilio2_provincia_1 : this.domicilio2_provincia_1 || '',
    domicilio2_telefono_1 : this.domicilio2_telefono_1 || '',
    cuenta_bancaria_titular : this.cuenta_bancaria_titular || '',
    cuenta_bancaria_dni : this.cuenta_bancaria_dni || '',
    cuenta_bancaria_iban_1 : this.cuenta_bancaria_iban_1 || '',
    cuenta_bancaria_iban_2 : this.cuenta_bancaria_iban_2 || '',
    cuenta_bancaria_iban_3 : this.cuenta_bancaria_iban_3 || '',
    cuenta_bancaria_iban_4 : this.cuenta_bancaria_iban_4 || '',
    cuenta_bancaria_iban_5 : this.cuenta_bancaria_iban_5 || '',
    comentarios : this.comentarios || '',
    checkbox_usuario_leida_cesion_imagenes : this.checkbox_usuario_leida_cesion_imagenes || '',
    checkbox_usuario_cesion_imagenes : this.checkbox_usuario_cesion_imagenes || '',
    date_registered: now || '',
  })
  .then((docRef)=>{
    if (docRef)
      console.log('Datos guardatos correctamente. ', docRef);
      //this.obtenerCentroEscolarInformacion();
      this.showSuccess('Datos guardatos correctamente.');
      this.router.navigate(['/admin/listados-usuarios'])
  })
  .catch(error => {
    console.log(error);
    this.showError('Hubo algún problema guardando los cambios.');
  })
  }


  volver(){
    this._location.back();
  }

  CrearUsuarioTipoSeleccionado(event: any){
    this.rol = event.target.value;
    console.log('this.rol', this.rol);
  }


    //metodos de toast para el usuario
    showSuccess(mensaje) {
      //let options = { closeButton: true, tapToDismiss: false,  titleClass: 'yellow' };
      //this.toast.success(mensaje, 'Toastr success!', options);
      this.toast.success(mensaje);
    }

    showError(mensaje) {
      //let options = { enableHtml: false,  positionClass: 'toast-bottom-right' };
      //this.toast.error(mensaje, 'Toastr error!', options);
      this.toast.error(mensaje);
    }

    showInfo(mensaje) {
      //let options = { extendedTimeOut: 30000, messageClass: 'pink' };
      //this.toast.info('Info message', 'Toastr info!', options);
      this.toast.info(mensaje);
    }

    showWarning(mensaje) {
      //let options = { progressBar: true,  timeOut: 3000,  toastClass: 'black'};
      //this.toast.warning('Warnig message', 'Toastr warning!', options);
      this.toast.warning(mensaje);
    }

}



// WEBPACK FOOTER //
// ./src/app/adminlistados-usuarios-crear/adminlistados-usuarios-crear.component.ts